import { render, staticRenderFns } from "./AtendimentoLpsRoute.vue?vue&type=template&id=7fd5cebc"
import script from "./AtendimentoLpsRoute.vue?vue&type=script&lang=js"
export * from "./AtendimentoLpsRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports